import { render, staticRenderFns } from "./LocationNetworkBasic.vue?vue&type=template&id=0a504b74&"
import script from "./LocationNetworkBasic.vue?vue&type=script&lang=js&"
export * from "./LocationNetworkBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports